// Native American Warriors Data - Group Two (Apache & Southwest Warriors)

// Quanah Parker's workout programs
const quanahParkerPrograms = [
    {
        id: 'half-blood-strength-training',
        name: 'Half-Blood Strength Training',
        description: 'Dual heritage power combining Comanche warrior tradition with strategic adaptation',
        pattern: 'w@da^',
        reps: 14,
        sets: 4,
        focus: 'Dual Heritage Power'
    },
    {
        id: 'comanche-horse-conditioning',
        name: 'Comanche Horse Conditioning',
        description: 'Elite mounted warrior training from the greatest riders of the Plains',
        pattern: '~w@ad',
        reps: 16,
        sets: 3,
        focus: 'Master Horseman'
    },
    {
        id: 'llano-estacado-workout',
        name: 'Llano Estacado Workout',
        description: 'Harsh plains conditioning forged in the vast Texas Panhandle',
        pattern: 'da@w^',
        reps: 18,
        sets: 3,
        focus: 'Plains Endurance'
    },
    {
        id: 'last-chief-protocol',
        name: 'Last Chief Protocol',
        description: 'Leadership training for those who must bridge the old ways and new world',
        pattern: '@wd^a',
        reps: 12,
        sets: 5,
        focus: 'Bridge Leadership'
    },
    {
        id: 'blue-eyed-warrior-training',
        name: 'Blue-Eyed Warrior Training',
        description: 'Unique strength that stands out while honoring traditional Comanche ways',
        pattern: '^@wad',
        reps: 20,
        sets: 3,
        focus: 'Unique Heritage'
    },
    {
        id: 'mixed-blood-mastery',
        name: 'Mixed Blood Mastery',
        description: 'Complete training for warriors who unite different worlds into one strength',
        pattern: 'w@da^!',
        reps: 22,
        sets: 3,
        focus: 'United Worlds'
    }
];

// Ten Bears's workout programs
const tenBearsPrograms = [
    {
        id: 'elder-wisdom-conditioning',
        name: 'Elder Wisdom Conditioning',
        description: 'Aged strength refined through decades of Comanche leadership',
        pattern: 'ad@w^',
        reps: 10,
        sets: 6,
        focus: 'Elder Wisdom'
    },
    {
        id: 'buffalo-hide-training',
        name: 'Buffalo Hide Training',
        description: 'Traditional Comanche strength wrapped in the power of the sacred buffalo',
        pattern: 'wa@^d',
        reps: 15,
        sets: 4,
        focus: 'Sacred Buffalo Power'
    },
    {
        id: 'painted-horse-workout',
        name: 'Painted Horse Workout',
        description: 'Ceremonial conditioning with the spiritual protection of war paint',
        pattern: '@dwa^',
        reps: 13,
        sets: 4,
        focus: 'Ceremonial Protection'
    },
    {
        id: 'storm-cloud-conditioning',
        name: 'Storm Cloud Conditioning',
        description: 'Powerful training that gathers strength like storm clouds over the plains',
        pattern: 'w^@ad',
        reps: 17,
        sets: 3,
        focus: 'Storm Power'
    },
    {
        id: 'comanche-council-training',
        name: 'Comanche Council Training',
        description: 'Diplomatic strength for chiefs who must speak with wisdom and authority',
        pattern: 'da^@w',
        reps: 11,
        sets: 5,
        focus: 'Council Authority'
    },
    {
        id: 'honored-chief-mastery',
        name: 'Honored Chief Mastery',
        description: 'Complete mastery training for one of the most respected Comanche leaders',
        pattern: 'wa@^da!',
        reps: 19,
        sets: 3,
        focus: 'Honored Leadership'
    }
];

// Geronimo's workout programs
const geronimoPrograms = [
    {
        id: 'apache-lightning-training',
        name: 'Apache Lightning Training',
        description: 'Explosive speed and agility training for desert warfare supremacy',
        pattern: 'gk@da',
        reps: 21,
        sets: 3,
        focus: 'Lightning Speed'
    },
    {
        id: 'desert-survival-conditioning',
        name: 'Desert Survival Conditioning',
        description: 'Harsh environment training forged in the unforgiving Southwest desert',
        pattern: 'ag@kd',
        reps: 16,
        sets: 4,
        focus: 'Desert Mastery'
    },
    {
        id: 'medicine-man-workout',
        name: 'Medicine Man Workout',
        description: 'Spiritual power training combining physical strength with sacred knowledge',
        pattern: 'ka@gd',
        reps: 18,
        sets: 3,
        focus: 'Sacred Medicine'
    },
    {
        id: 'resistance-leader-protocol',
        name: 'Resistance Leader Protocol',
        description: 'Unbreakable conditioning for those who never surrender to overwhelming odds',
        pattern: '@gkad',
        reps: 24,
        sets: 3,
        focus: 'Eternal Resistance'
    },
    {
        id: 'legendary-escape-training',
        name: 'Legendary Escape Training',
        description: 'Elusive conditioning for warriors who can vanish into the desert like smoke',
        pattern: 'gad@k',
        reps: 14,
        sets: 5,
        focus: 'Desert Phantom'
    },
    {
        id: 'apache-legend-mastery',
        name: 'Apache Legend Mastery',
        description: 'Ultimate training for the most famous Apache warrior in history',
        pattern: 'gk@ad!',
        reps: 26,
        sets: 3,
        focus: 'Legendary Apache'
    }
];

// Cochise's workout programs
const cochisePrograms = [
    {
        id: 'chiricahua-chief-training',
        name: 'Chiricahua Chief Training',
        description: 'Noble leadership conditioning from the mountainous Apache strongholds',
        pattern: 'k@gad',
        reps: 15,
        sets: 4,
        focus: 'Mountain Chief'
    },
    {
        id: 'dragoon-mountains-workout',
        name: 'Dragoon Mountains Workout',
        description: 'Rocky terrain conditioning in the fortress-like Dragoon Mountain range',
        pattern: '@kgda',
        reps: 17,
        sets: 3,
        focus: 'Mountain Fortress'
    },
    {
        id: 'aristocratic-warrior-conditioning',
        name: 'Aristocratic Warrior Conditioning',
        description: 'Refined strength training befitting Apache nobility and natural leadership',
        pattern: 'ga@kd',
        reps: 13,
        sets: 4,
        focus: 'Noble Warrior'
    },
    {
        id: 'peace-treaty-protocol',
        name: 'Peace Treaty Protocol',
        description: 'Diplomatic strength for leaders who can negotiate from a position of power',
        pattern: 'k@dag',
        reps: 11,
        sets: 5,
        focus: 'Diplomatic Power'
    },
    {
        id: 'apache-honor-training',
        name: 'Apache Honor Training',
        description: 'Honor-based conditioning that maintains integrity while building strength',
        pattern: 'agk@d',
        reps: 19,
        sets: 3,
        focus: 'Honorable Strength'
    },
    {
        id: 'respected-leader-mastery',
        name: 'Respected Leader Mastery',
        description: 'Complete training for one of the most respected Apache leaders in history',
        pattern: 'k@gda!',
        reps: 21,
        sets: 3,
        focus: 'Respected Leadership'
    }
];

// Mangas Coloradas's workout programs
const mangasColoradasPrograms = [
    {
        id: 'giant-warrior-training',
        name: 'Giant Warrior Training',
        description: 'Massive strength training for the towering Apache war leader',
        pattern: 'gka@d',
        reps: 20,
        sets: 3,
        focus: 'Giant Strength'
    },
    {
        id: 'chihuahuan-desert-conditioning',
        name: 'Chihuahuan Desert Conditioning',
        description: 'Harsh desert environment training across the vast Chihuahuan landscape',
        pattern: 'ag@dk',
        reps: 18,
        sets: 4,
        focus: 'Desert Endurance'
    },
    {
        id: 'mesa-overlord-workout',
        name: 'Mesa Overlord Workout',
        description: 'High ground tactical training from commanding desert mesa positions',
        pattern: 'k@agd',
        reps: 16,
        sets: 4,
        focus: 'High Ground Command'
    },
    {
        id: 'red-sleeves-protocol',
        name: 'Red Sleeves Protocol',
        description: 'Distinctive strength training as memorable as the famous red sleeves',
        pattern: '@gkda',
        reps: 22,
        sets: 3,
        focus: 'Distinctive Power'
    },
    {
        id: 'tribal-unifier-training',
        name: 'Tribal Unifier Training',
        description: 'Leadership conditioning for bringing together scattered Apache bands',
        pattern: 'ga@dk',
        reps: 14,
        sets: 5,
        focus: 'Unifying Leadership'
    },
    {
        id: 'apache-giant-mastery',
        name: 'Apache Giant Mastery',
        description: 'Ultimate training for the legendary giant of the Apache nation',
        pattern: 'gka@d!',
        reps: 24,
        sets: 3,
        focus: 'Legendary Giant'
    }
];

// Victorio's workout programs
const victorioPrograms = [
    {
        id: 'black-range-training',
        name: 'Black Range Training',
        description: 'Mountain warfare conditioning in the rugged Black Range of New Mexico',
        pattern: 'kg@ad',
        reps: 17,
        sets: 3,
        focus: 'Mountain Warfare'
    },
    {
        id: 'guerrilla-leader-conditioning',
        name: 'Guerrilla Leader Conditioning',
        description: 'Hit-and-run tactical training for mobile desert warfare mastery',
        pattern: 'a@gkd',
        reps: 19,
        sets: 3,
        focus: 'Guerrilla Tactics'
    },
    {
        id: 'alert-scout-workout',
        name: 'Alert Scout Workout',
        description: 'Hypervigilant conditioning for warriors who must constantly scan for danger',
        pattern: 'gd@ka',
        reps: 15,
        sets: 4,
        focus: 'Hypervigilance'
    },
    {
        id: 'new-mexico-resistance-training',
        name: 'New Mexico Resistance Training',
        description: 'Regional resistance conditioning across the harsh New Mexico territories',
        pattern: '@kgad',
        reps: 21,
        sets: 3,
        focus: 'Regional Resistance'
    },
    {
        id: 'fierce-warrior-protocol',
        name: 'Fierce Warrior Protocol',
        description: 'Aggressive conditioning for warriors known for their fierce determination',
        pattern: 'kad@g',
        reps: 13,
        sets: 5,
        focus: 'Fierce Determination'
    },
    {
        id: 'mountain-chief-mastery',
        name: 'Mountain Chief Mastery',
        description: 'Complete mountain warfare mastery for one of the greatest Apache war leaders',
        pattern: 'kg@ad!',
        reps: 23,
        sets: 3,
        focus: 'Mountain Mastery'
    }
];

// Main Native American warriors data object - Group Two
const nativeAmericanTwoTrainersData = {
    'quanah-parker': {
        id: 'quanah-parker',
        name: 'Quanah Parker',
        specialization: 'Mixed Heritage & Adaptive Leadership',
        image: '/assets/images/Quanah-Parker.jpg',
        experience: '60+ years',
        category: 'native-american',
        color: '#4169E1',
        secondaryColor: '#C0C0C0',
        intro: `The last great chief of the Comanche, Quanah Parker bridged two worlds with his mixed Anglo-Comanche heritage. His training develops adaptive strength that honors tradition while embracing necessary change. Students learn that true leadership comes from understanding multiple perspectives and uniting them into powerful action.`,
        programs: quanahParkerPrograms
    },
    'ten-bears': {
        id: 'ten-bears',
        name: 'Ten Bears',
        specialization: 'Elder Wisdom & Sacred Buffalo Power',
        image: '/assets/images/Ten-Bears.jpg',
        experience: '75+ years',
        category: 'native-american',
        color: '#8B4513',
        secondaryColor: '#C0C0C0',
        intro: `The revered Comanche elder whose wisdom guided his people through their most challenging times, Ten Bears embodied the sacred connection between warrior and buffalo. His training builds strength that deepens with age, teaching that true power comes from patience, wisdom, and spiritual connection to the natural world.`,
        programs: tenBearsPrograms
    },
    'geronimo': {
        id: 'geronimo',
        name: 'Geronimo',
        specialization: 'Desert Lightning & Medicine Power',
        image: '/assets/images/Geronimo.jpg',
        experience: '79+ years',
        category: 'native-american',
        color: '#CD853F',
        secondaryColor: '#C0C0C0',
        intro: `The legendary Apache medicine man and warrior whose name became synonymous with fierce resistance, Geronimo mastered both spiritual power and desert warfare. His training develops the explosive speed and elusive movement needed to survive impossible odds while maintaining sacred connection to Apache traditions.`,
        programs: geronimoPrograms
    },
    'cochise': {
        id: 'cochise',
        name: 'Cochise',
        specialization: 'Mountain Fortress & Noble Leadership',
        image: '/assets/images/Cochise.jpg',
        experience: '61+ years',
        category: 'native-american',
        color: '#2F4F4F',
        secondaryColor: '#C0C0C0',
        intro: `The noble Chiricahua Apache chief whose intelligence and dignity earned respect from both enemies and allies, Cochise ruled from the mountain fortress of the Dragoon Mountains. His training builds the refined strength and tactical intelligence needed for leadership that commands respect through honor rather than fear.`,
        programs: cochisePrograms
    },
    'mangas-coloradas': {
        id: 'mangas-coloradas',
        name: 'Mangas Coloradas',
        specialization: 'Giant Strength & Tribal Unity',
        image: '/assets/images/Mangas-Coloradas.jpg',
        experience: '70+ years',
        category: 'native-american',
        color: '#8B0000',
        secondaryColor: '#C0C0C0',
        intro: `The towering Apache giant whose physical presence matched his leadership abilities, Mangas Coloradas stood over six and a half feet tall and united scattered Apache bands. His training develops massive strength and commanding presence, teaching that sometimes leadership means being the immovable force that others can rally behind.`,
        programs: mangasColoradasPrograms
    },
    'victorio': {
        id: 'victorio',
        name: 'Victorio',
        specialization: 'Mountain Warfare & Guerrilla Tactics',
        image: '/assets/images/Victorio.jpg',
        experience: '50+ years',
        category: 'native-american',
        color: '#556B2F',
        secondaryColor: '#C0C0C0',
        intro: `The fierce Apache war leader who perfected mountain guerrilla warfare in the Black Range of New Mexico, Victorio never lost his edge or vigilance. His training develops the alert conditioning and tactical movement needed for mobile warfare, teaching that survival depends on constant awareness and lightning-fast adaptation.`,
        programs: victorioPrograms
    }
};

// Export the data
export default nativeAmericanTwoTrainersData;